const isLoggedIn = state => {
  return !!state.token
}

const isLoading = state => {
  return state.loading
}

const getToken = state => {
  return state.token
}

export default {
  isLoggedIn,
  isLoading,
  getToken
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js